<template>
  <input
    v-model="inputValue"
    class="form-control me-3 my-1"
    type="password"
    placeholder="New Password"
  />
  <button
    type="button"
    class="btn btn-primary btn-sm mx-2"
    @click="changeUserPassword"
  >
    Update
  </button>
  <button
    type="button"
    class="btn btn-danger btn-sm mx-2"
    @click="deactivateComponentFunc()"
  >
    Close
  </button>
</template>

<script lang="ts">
import { updatePassword } from '@/common/api';
import { defineComponent } from 'vue';
import { handleError } from '@/common/errors';

export default defineComponent({
  name: 'AdminTableChangePasswordButton',

  props: {
    recordId: {
      type: Number,
      required: true,
    },
    deactivateComponentFunc: {
      type: Function,
      required: true,
    },
    reloadAdminTable: {
      type: Function,
      required: true,
    },
    recreateTableFunc: {
      type: Function,
      required: true,
    },
  },

  data() {
    return {
      inputValue: '',
    };
  },

  methods: {
    async changeUserPassword() {
      try {
        await updatePassword(this.recordId, this.inputValue);
      } catch (error: unknown) {
        handleError(error, 'Failed to update password');
      }

      this.deactivateComponentFunc();
      this.recreateTableFunc();
    },
  },
});
</script>
